import { render, staticRenderFns } from "./CreditDetailsModal.vue?vue&type=template&id=64ef8bbf"
import script from "./CreditDetailsModal.vue?vue&type=script&lang=js"
export * from "./CreditDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports